import { TestDemoStyles } from "./clientStyles/Testdemo";
import { ClientNames } from "./types";

export const DarkStyles = ():{[key:string]:string} => ({
  [ClientNames.Test]: TestDemoStyles,
})
